import React from "react";
import { Button } from "@pacificoseguros/pixie/react/button";
import { DatalayerModalButton } from "./datalayer-modal-button";

type Props = React.ComponentProps<typeof Button> &
    React.ComponentProps<typeof DatalayerModalButton>;

export const DatalayerModalPixieButton: React.FC<Props> = (props: Props) => {
    return (
        <DatalayerModalButton
            as={Button}
            data-testid="DatalayerModalPixieButton"
            {...props}
        />
    );
};
